export const PILOT_THIRD_PARTY_SENSORS_CARD_FRENCH_LOCALE = {
  title: "Capteurs tiers",
};
